import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoaderService } from '../../shared/services/loader/loader.service';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  @Input() show: boolean = false
  @Input() size: 'large' | 'small' = 'large'

  constructor(public loaderService: LoaderService) { }
}

